import { PropsWithChildren } from "react";
import { Grid, useTheme } from "@mui/material";
import { NavigationMenu } from "~components/Organisms";

const Common = ({ children }: PropsWithChildren) => {
  const theme: any = useTheme();

  return (
    <Grid
      container
      display="flex"
      flexWrap="nowrap"
      sx={{
        backgroundColor: theme.palette.grey[900],
        minHeight: "100vh",
        minWidth: "100vw",
      }}
    >
      <Grid item sx={{ display: "flex", alignItems: "flex-start", flexShrink: 0 }}>
        <NavigationMenu />
      </Grid>
      <Grid
        item
        xs
        sx={{
          pt: 9,
          pr: 2.5,
          pb: 9,
          pl: 2.5,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default Common;
